import React, { ComponentPropsWithoutRef, MouseEvent } from 'react';
import SeoResource from '../../../../../../services/resources/SeoResource';
import { ProductInterface } from '../../../../../../services/exports/Interfaces';
import classnames from 'classnames';
import HeartIcon from '../../../../../../assets/logo/HeartIcon';
import PriceComparison from '../../../../../../components-library/menu/PriceComparison';
import PlusIcon from '../../../../../../assets/logo/PlusIcon';
import useProductLikes from '../../../../../../hooks/global/useProductLikes';

type RecommendedProductItemProps = ComponentPropsWithoutRef<'article'> & {
  product: ProductInterface;
};

const RecommendedProductItem = ({ product, className, ...rest }: RecommendedProductItemProps) => {
  const { toggleProductLike, isLiked: checkIsLiked } = useProductLikes();
  const isLiked = checkIsLiked(product.id);
  const likesCount = product.likes_count;
  const onLikeClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    toggleProductLike(product.id);
  };

  return (
    <article
      className={classnames(
        'border rounded-lg h-full w-[306px] flex-shrink-0 snap-center flex justify-between overflow-hidden bg-white',
        className,
      )}
      {...rest}
    >
      <div className="space-y-sm flex-shrink-0 p-md">
        <h3 className="text-base font-normal">{product.name}</h3>
        <div className="flex space-x-6 items-center">
          <PriceComparison
            actualPrice={product.actual_price}
            originalPrice={product.original_price}
            className="text-gray-700"
          />
          <div className="flex items-center justify-center space-x-2" onClick={onLikeClick}>
            <HeartIcon
              filled={!!isLiked}
              className={classnames('h-3', {
                'fill-danger': isLiked,
                'fill-mobile-secondary': !isLiked,
              })}
            />
            <span className="text-xs text-gray-700">{likesCount}</span>
          </div>
        </div>
      </div>
      <figure className="overflow-hidden rounded-r-lg relative w-[90px] h-full">
        {product?.thumbnail_url && (
          <img
            src={product.thumbnail_url}
            alt={SeoResource.toAltText(`${product?.name} image`)}
            className="size-full object-contain"
          />
        )}
        <span className="bottom-sm size-6 right-sm absolute bg-brand-primary rounded-[5px] flex items-center justify-center">
          <PlusIcon className="size-3" color="white" />
        </span>
      </figure>
    </article>
  );
};

export default RecommendedProductItem;
